"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { combineEmploymentTypes } from "@repo/design-system/utils/helpers";
import ClockIcon from "~/components/icons/clock-icon-eon";
import FileIcon from "~/components/icons/file-icon-eon";
import Home from "~/components/icons/home-eon";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
import { FormattedTitle } from "../ad/formatted-title-eon";
export default function HeaderImageJobad(t0) {
  const $ = _c(28);
  const {
    job
  } = t0;
  const t = useLanguage();
  let t1;
  if ($[0] !== job.content.headerImage) {
    t1 = <div className="relative aspect-video lg:aspect-auto"><CustomImage className="h-full max-h-[700px] object-cover object-left" fetchPriority="high" height={1070} priority={true} sizes="(max-width: 1024px) 100vw, 60vw" src={job.content.headerImage} width={2000} /></div>;
    $[0] = job.content.headerImage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      fontFamily: "var(--font-eon-headline), sans-serif"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== job.data.title) {
    t3 = <div className="text-lg 2xl:text-xl"><h1 className="mb-6 text-3xl 2xl:text-4xl" data-source="job" style={t2}><FormattedTitle input={job.data.title} /></h1></div>;
    $[3] = job.data.title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Home className="mt-1 mr-3" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== job.data.company) {
    t5 = <li className="flex w-full items-center">{t4}<span data-source="job">{job.data.company}</span></li>;
    $[6] = job.data.company;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FileIcon className="mt-1 mr-3" />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== job.data.contract || $[10] !== job.data.remote) {
    t7 = <li className="flex w-full items-center">{t6}<span data-source="job">{job.data.remote}, {job.data.contract}</span></li>;
    $[9] = job.data.contract;
    $[10] = job.data.remote;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ClockIcon className="mt-1 mr-3" />;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== job.data.employmentType || $[14] !== t) {
    t9 = combineEmploymentTypes(job.data.employmentType, t);
    $[13] = job.data.employmentType;
    $[14] = t;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t9) {
    t10 = <li className="flex w-full items-center">{t8}<span data-source="job">{t9}</span></li>;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t5 || $[20] !== t7) {
    t11 = <div><ul className="flex flex-col text-lg lg:mt-8 2xl:text-xl">{t5}{t7}{t10}</ul></div>;
    $[18] = t10;
    $[19] = t5;
    $[20] = t7;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t3) {
    t12 = <div className="h-full px-6 py-10 lg:max-w-[680px] lg:justify-self-start lg:px-10"><div className="mb-4 flex h-full flex-col justify-between 2xl:justify-end 2xl:gap-10">{t3}{t11}</div></div>;
    $[22] = t11;
    $[23] = t3;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t1 || $[26] !== t12) {
    t13 = <section className="w-full bg-primary text-white lg:flex lg:justify-center print:hidden"><div className="grid w-full auto-cols-fr lg:grid-flow-col 2xl:auto-cols-[3fr_2fr]">{t1}{t12}</div></section>;
    $[25] = t1;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
}